import React, { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Benefits from "@/components/Benefits";
import Recipe from "@/components/Recipe";
import About from "@/components/About";
import CatBand from "@/components/CatBand";
import VetTrust from "@/components/VetTrust";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink font-serif text-2xl text-gold">
          Ceva n-a mers bine. Reîmprospătează pagina.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-ink text-cream antialiased">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Benefits />
          <Recipe />
          <About />
          <CatBand />
          <VetTrust />
          <Gallery />
          <Contact />
        </main>
        <Footer />
        <FloatingContact />
      </div>
    </ErrorBoundary>
  );
}

export default App;
